import { MeterReadingsFilters } from "@features/cx/transfer/types";
import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

// ================================
// TRANSFER KEY FACTORY
// ================================
export const transferKeyFactory = {
    // Consumer operations
    consumerSearch: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "transferRequests",
        "consumerSearch",
        filters,
    ],
    exportList: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "transferRequests",
        "transferRequestsExport",
        filters,
    ],
    consumerMetaData: (params?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "transferRequests",
        "consumerMetaData",
        params,
    ],
    
    // Utility configuration
    utilityConfig: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "transferRequests",
        "utilityConfig",
        filters,
    ],
    
    // Choices
    consumerRelationChoices: (): [ModuleType, EntityType, ActionType] => [
        "cx",
        "transferRequests",
        "consumerRelationChoices",
    ],
    
    // Transfer requests
    list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "transferRequests",
        "list",
        filters,
    ],
    details: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "details",
        requestId,
    ],
    create: (): [ModuleType, EntityType, ActionType] => [
        "cx",
        "transferRequests",
        "create",
    ],
    update: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "update",
        requestId,
    ],
    delete: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "delete",
        requestId,
    ],
    
    // Summary and statistics
    summary: (params?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "transferRequests",
        "summary",
        params,
    ],
    
    // Document operations
    documentUpdate: (requestId: string, documentId: string): [ModuleType, EntityType, ActionType, string, string] => [
        "cx",
        "transferRequests",
        "documentUpdate",
        requestId,
        documentId,
    ],
    documentApprove: (requestId: string, documentId: string): [ModuleType, EntityType, ActionType, string, string] => [
        "cx",
        "transferRequests",
        "documentApprove",
        requestId,
        documentId,
    ],
    documentReject: (requestId: string, documentId: string): [ModuleType, EntityType, ActionType, string, string] => [
        "cx",
        "transferRequests",
        "documentReject",
        requestId,
        documentId,
    ],
    
    // Status operations
    approve: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "approve",
        requestId,
    ],
    reject: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "reject",
        requestId,
    ],
    acknowledge: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "acknowledge",
        requestId,
    ],
    complete: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "complete",
        requestId,
    ],
    hold: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "hold",
        requestId,
    ],
    
    // Workflow operations
    workflow: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "workflow",
        requestId,
    ],
    completeWorkflow: (requestId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "transferRequests",
        "completeWorkflow",
        requestId,
    ],
    meterReadings: (
    filters: MeterReadingsFilters
  ): [ModuleType, EntityType, ActionType, MeterReadingsFilters] => [
    "cx",
    "transferRequests",
    "meterReadings",
    filters,
  ],
  consumerBill: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "transferRequests",
    "consumerBill",
    filters,
  ],
  billTemplates: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "transferRequests",
    "billTemplates",
  ],
  billDetails: (billId: string): [ModuleType, EntityType, ActionType, string] => ["cx", "transferRequests", "bill-details", billId],

  meterReadingStatus: (): [ModuleType, EntityType, any] => [
    "cx",
    "transferRequests",
    "meterReadingStatus",
  ],
 paymentForBill: (consumerId: string,billId: string): [ModuleType, EntityType, any, string, string] => ["cx", "transferRequests", "payment-for-bill", consumerId, billId],

};